import { render, staticRenderFns } from "./QuoteVehicleDamage.vue?vue&type=template&id=2cd8e84c&scoped=true"
import script from "./QuoteVehicleDamage.vue?vue&type=script&lang=js"
export * from "./QuoteVehicleDamage.vue?vue&type=script&lang=js"
import style0 from "./QuoteVehicleDamage.vue?vue&type=style&index=0&id=2cd8e84c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cd8e84c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/flexiquote/flexiquote/uniqms-vue-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cd8e84c')) {
      api.createRecord('2cd8e84c', component.options)
    } else {
      api.reload('2cd8e84c', component.options)
    }
    module.hot.accept("./QuoteVehicleDamage.vue?vue&type=template&id=2cd8e84c&scoped=true", function () {
      api.rerender('2cd8e84c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/quote/QuoteVehicleDamage.vue"
export default component.exports